<template>
  <div class="main-row">
    <div class="left-column">
      <div class="infobox">
        <h4>Steg 2 av 2</h4>
        <p>Bare litt igjen nå!</p>
        <p>Dersom du jobber i utlandet, kan du la "Din kommune"-feltet stå blankt</p>
      </div>
    </div>
    <div class="right-column">
      <v-form v-model="valid" class="form">
        <span class="fagfelt">
          <v-select
              attach=".fagfelt"
              :items="field_options"
              v-model="user.field"
              :rules="rules.required"
              placeholder="Ditt fagfelt"
              prepend-icon="work"
              required
          ></v-select>
        </span>
        <span class="counties">
          <v-select
              attach=".counties"
              v-model="user.county"
              :items="counties"
              :rules="rules.required"
              placeholder="Ditt fylke"
              prepend-icon="location_city"
              required
          ></v-select>
        </span>
        <span class="education">
          <v-select
              attach=".education"
              :items="education_options"
              v-model="user.education"
              :rules="rules.required"
              placeholder="Utdanningsnivå"
              prepend-icon="school"
              required
          ></v-select>
        </span>
      <br><v-btn :loading="loading" :disabled="!valid" @click="submitForm" block color="primary">Se resultat<v-icon>navigate_next</v-icon></v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
  export default {
    props: { 
      user: Object,
      db: Object 
    },
    data: () => ({
      valid: true,
      loading: false,
      rules: {
        required: [ 
          val => !!val || 'Denne må fylles ut' 
        ]
      },
      counties: [
        "Østfold",
        "Akershus",
        "Oslo",
        "Hedmark",
        "Oppland",
        "Buskerud",
        "Vestfold",
        "Telemark",
        "Aust-Agder",
        "Vest-Agder",
        "Rogaland",
        "Hordaland",
        "Sogn og Fjordane",
        "Møre og Romsdal",
        "Trøndelag",
        "Nordland",
        "Troms",
        "Finnmark"
      ],
      field_options: [
        'IT-leder',
        'Systemarkitekt',
        'Prosjektleder',
        'IT-sikkerhetsarbeider',
        'IT-selger',
        'Programvareutvikler',
        'Webutvikler',
        'Systemtekniker',
        'Systemadministrator',
        'Driftstekniker',
        'Brukerstøtte-arbeider',
        'Designer',
        'Test/QA-arbeider',
        'Embedded-utvikler'
      ],
      education_options: [
        "Grunnskolenivå", 
        "Videregående nivå",
        "Høyere utdanning, 3 år",
        "Høyere utdanning, 5 år+"
      ],
      salaryRules: [
        v => !!v || 'E-mail is required',
      ]
    }),
    methods: {
      submitForm() {
        this.user.created_at = new Date()
        this.loading = true
        //Create the user document
        this.db.collection('users').doc(this.user.user_id).set(this.user)
        //Listen for changes to the user document
        this.db.collection('users').doc(this.user.user_id)
          .onSnapshot((doc) => {
            let data = doc.data()
            //An expected salary means the cloud function calculation has finished. 
            if(data && data.expected_salary > 0) {
              this.user.expected_salary = data.expected_salary
              //We want to make a copy of the first entry each user makes. The following checks if a document already exists, and adds it if it does not.
              const first_entry = this.db.collection('first_entries').doc(this.user.user_id)
              first_entry.get()
                .then((docSnapshot) => {
                  if (!docSnapshot.exists) {
                    this.db.collection('first_entries').doc(this.user.user_id).set(this.user)
                  } 
              })
            } 
          })
      } 
    }
    
  }
</script>

<style lang="scss">

.digi-kalk {
  //Dirty fix to make the dropdown position work when app is embedded
  .v-menu__content {
    top: auto !important;
    left: auto !important;
    margin-left: 33px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/FormFinal.vue